import type { TransactionItemDetail } from 'models';
import { useState } from 'react';
import { Button, Col, Dropdown, More2LineIcon, Row, Text } from 'ui';
import { TransactionViewBasedOnUser } from '../../components';
import { useActions } from './hooks';
import { TestimonialEditModal } from './testimonial-edit-modal';

type P = {
  testimonial: TransactionItemDetail;
};
const Testimonials = ({ testimonial }: P) => {
  const [isEditTestimonialModalOpened, setIsEditTestimonialModalOpened] = useState(false);

  const { actions, contextHolders } = useActions({
    onTestimonialEdit: setIsEditTestimonialModalOpened,
    testimonial,
  });

  return (
    <>
      <Row align="middle" gutter={['xs', 'xs']} justify="space-between">
        <TransactionViewBasedOnUser displayMode="detailed" transaction={testimonial} />
        <Col>
          <Dropdown menu={{ items: actions }} trigger={['click']}>
            <Button icon={<More2LineIcon />} type="link-secondary" />
          </Dropdown>
        </Col>
        <Col span={24}>
          <Text>{testimonial.textContent}</Text>
        </Col>
      </Row>

      <TestimonialEditModal
        isOpened={isEditTestimonialModalOpened}
        onClose={() => {
          setIsEditTestimonialModalOpened(false);
        }}
        testimonial={testimonial}
      />
      {contextHolders}
    </>
  );
};

export default Testimonials;
